import { RequestStatus } from '@occc-app/lib/constants';
import { Links, Meta } from '@occc-app/Activate/apiTypes';

import { State } from './types';

export const pageableResponseParser = (links: Links = {}, meta: Meta): State => {
  const { first, last, next, prev } = links;
  return {
    status: RequestStatus.OK,
    records: meta.record_count,
    first,
    last,
    next,
    prev,
  };
};

export const pageableResponseErr = (): State => ({
  status: RequestStatus.ERR,
  records: 0,
});
